import { render, staticRenderFns } from "./Other.vue?vue&type=template&id=6c437c61&scoped=true"
import script from "./Other.vue?vue&type=script&lang=js"
export * from "./Other.vue?vue&type=script&lang=js"
import style0 from "./Other.vue?vue&type=style&index=0&id=6c437c61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c437c61",
  null
  
)

export default component.exports